<span class="currency-string" [id]="id" *ngIf="animation === ''" [innerText]="value | desjardinsCurrency"></span>
<span
  class="currency-string"
  [id]="id"
  *ngIf="animation === 'countUpAnimation'"
  [countUp]="value"
  [options]="countUpAnimationOptions"
  [reanimateOnClick]="false"
>
  0
</span>
<span class="periodicy" *ngIf="periodicity" [innerText]="periodicity"> </span>
